import { render, staticRenderFns } from "./coachProportionSetting.vue?vue&type=template&id=1aabdc38&scoped=true"
import script from "./coachProportionSetting.vue?vue&type=script&lang=ts"
export * from "./coachProportionSetting.vue?vue&type=script&lang=ts"
import style0 from "./coachProportionSetting.vue?vue&type=style&index=0&id=1aabdc38&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aabdc38",
  null
  
)

export default component.exports